import useSWR from "swr";
import { JSON_FETCHER } from "@/components/fetcher";
import { Contact } from "@/components/models/Contact";

export interface PaginationInfo {
  page: number;
  per_page: number;
  total: number;
  total_pages: number;
}

export default function useContacts(
  page: number = 1,
  perPage: number = 50,
  search: string = "",
): {
  contacts: Contact[];
  pagination: PaginationInfo | null;
  isLoading: boolean;
  isError: any;
} {
  const queryParams = new URLSearchParams({
    page: page.toString(),
    per_page: perPage.toString(),
  });

  if (search) {
    queryParams.append("search", search);
  }

  const { data, error } = useSWR(`/web_api/contacts?${queryParams}`, JSON_FETCHER);

  return {
    contacts: data?.contacts || [],
    pagination: data?.pagination || null,
    isLoading: !(data || error),
    isError: error,
  };
}
